<div class="notificationDropdown" #notificationDropdown>
   <div class="">
      <audio id="messageReceivedNotification">
         <source src="/notification.mp3" type="audio/mpeg">
      </audio>
   </div>
</div>
